import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Building2, MapPin, Phone, Mail } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function ConcesionarioModal({
  isOpen,
  onClose,
  concesionarioSeleccionado,
  setConcesionarioSeleccionado
}) {
  const [concesionarios, setConcesionarios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const fetchConcesionarios = async () => {
      setLoading(true);
      try {
        const res = await api.get('/concesionarios?limit=100');
        const data = res.data.data || res.data || [];
        // Solo concesionarios activos para asignación
        setConcesionarios(data.filter((c) => c.activo !== false));
      } catch (error) {
        toast.error('Error al cargar concesionarios');
        setConcesionarios([]);
      } finally {
        setLoading(false);
      }
    };
    fetchConcesionarios();
  }, [isOpen]);

  const handleSelectConcesionario = (concesionario) => {
    setConcesionarioSeleccionado(concesionario);
    toast.success(`Concesionario ${concesionario.nombre} seleccionado`);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="bg-gradient-to-br from-[#2A2A2A] to-[#2A2A2A] border border-[#3B82F6]/30 rounded-2xl p-8 max-w-3xl"
        data-testid="concesionario-modal"
      >
        <DialogTitle className="text-2xl font-heading font-bold text-[white] mb-4 flex items-center gap-2">
          <Building2 className="w-6 h-6 text-[#3B82F6]" />
          Seleccionar Concesionario
        </DialogTitle>
        <DialogDescription className="text-[#666666] font-body mb-6">
          Selecciona el concesionario donde el cliente retirará su moto
        </DialogDescription>

        {loading ? (
          <div className="py-12 text-center text-[#F5A623] font-semibold" data-testid="concesionarios-loading">
            Cargando concesionarios...
          </div>
        ) : concesionarios.length === 0 ? (
          <div className="py-12 text-center" data-testid="concesionarios-empty">
            <Building2 className="w-14 h-14 text-[#666666] mx-auto mb-4" />
            <p className="text-[#666666] text-lg">No hay concesionarios registrados</p>
            <p className="text-[#666666] text-sm mt-2">
              Agrégalos desde la sección Concesionarios del panel
            </p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {concesionarios.map((concesionario) => (
              <button
                key={concesionario.id}
                onClick={() => handleSelectConcesionario(concesionario)}
                data-testid={`select-concesionario-${concesionario.id}`}
                className={`text-left p-6 border-2 rounded-lg transition-all hover:border-[#3B82F6] hover:bg-[#3B82F6]/10 ${
                  concesionarioSeleccionado?.id === concesionario.id
                    ? 'border-[#3B82F6] bg-[#3B82F6]/10'
                    : 'border-white/10 bg-[#2A2A2A]'
                }`}
              >
                <div className="flex items-start gap-3">
                  <Building2 className="w-6 h-6 text-[#3B82F6] flex-shrink-0 mt-1" />
                  <div className="flex-1">
                    <h3 className="text-white font-bold text-lg mb-2">{concesionario.nombre}</h3>
                    <p className="text-[#666666] text-sm mb-1 flex items-center gap-1">
                      <MapPin className="w-3 h-3" /> {concesionario.direccion}
                      {concesionario.ciudad ? `, ${concesionario.ciudad}` : ''}
                    </p>
                    <p className="text-[#666666] text-sm mb-1 flex items-center gap-1">
                      <Phone className="w-3 h-3" /> {concesionario.telefono}
                    </p>
                    <p className="text-[#3B82F6] text-sm flex items-center gap-1">
                      <Mail className="w-3 h-3" /> {concesionario.email}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}

        {concesionarioSeleccionado && (
          <div className="mt-6 p-4 bg-[#10B981]/20 border border-[#10B981]/30 rounded-lg">
            <p className="text-[#10B981] font-semibold text-center">
              ✓ Concesionario seleccionado: {concesionarioSeleccionado.nombre}
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
